module.exports = __webpack_public_path__ + "img/trust-badge.b9114abc.png";